import React, { Component } from 'react'
import FontAwesome from 'react-fontawesome'
import { Tabs, Tab, Breadcrumb } from 'react-bootstrap'
import {connect} from 'react-redux'
import {Switch,Route,withRouter} from 'react-router-dom'
import ReportTyreRepairInsidePage from './ReportTyreRepairInsidePage'
import ReportTyreRepairPage from './ReportTyreRepairPage'
class ReportAllTyreRepairPage extends Component {
    constructor(props) {
      super(props)
      
      this.state = {
        is_tab:true,
        activeKey:'inside',
        showTbReportTyreRepairInsidePage:false,
        showTbReportTyreRepairPage:false
      }
    }

    componentDidMount() {
        this.setTab()
    }
    
    setTab() {
        let {location} = this.props
        if (location.pathname==='/outside')
            this.onTabsSelect('outside')
        else
            this.onTabsSelect('inside')
    }

    onTabsSelect(key) {
        let pathname = '/'+key
        this.setState({activeKey:key,showTbReportTyreRepairInsidePage:false,showTbReportTyreRepairPage:false})
        this.props.history.push({pathname:pathname,search:'',state:{}})
    }

    onShowTabs(status) {
        this.setState({is_tab:status,showTbReportTyreRepairInsidePage:false,showTbReportTyreRepairPage:false})
    }
    
    onBreadcrumbClick(key) {
        this.setState({is_tab:true,activeKey:key})
        this.props.history.push({pathname:'/'+key,search:'',state:{}})
        if (key==='inside')
            this.setState({showTbReportTyreRepairInsidePage:true,showTbReportTyreRepairPage:false})
        else if (key==='outside')  
            this.setState({showTbReportTyreRepairInsidePage:false,showTbReportTyreRepairPage:true})
    }

    onRowSelect() {

    }

    renderReportTyreRepairInsideTab() {
        return(
            <ReportTyreRepairInsidePage
                ref='report_tyre_repair_inside'
                onShowTabs={this.onShowTabs.bind(this)}
                onRowSelect={this.onRowSelect.bind(this)}
                showTbReportTyreRepairInsidePage={this.state.showTbReportTyreRepairInsidePage}
            />
        )
    }

    renderReportTyreRepairTab() {
        return(
            <ReportTyreRepairPage
                ref='report_tyre_repair'
                onShowTabs={this.onShowTabs.bind(this)}
                onRowSelect={this.onRowSelect.bind(this)}
                showTbReportTyreRepairPage={this.state.showTbReportTyreRepairPage}
            />
        )
    }

    render() {
        let {activeKey,is_tab} = this.state
        let titleTab0 = 'รายงานซ่อมยางภายใน'
        let titleTab1 = 'รายงานซ่อมยางภายนอก'
        return(
            <div>
                {is_tab?
                <Tabs 
                    activeKey={activeKey}
                    id='all-tyre-repair-tabs'
                    onSelect={this.onTabsSelect.bind(this)}
                >
                    <Tab eventKey={'inside'} title={titleTab0}></Tab>
                    <Tab eventKey={'outside'} title={titleTab1}></Tab>
                </Tabs>
                :
                <Breadcrumb style={{marginBottom:'0'}}>
                    <Breadcrumb.Item active={false} onClick={this.onBreadcrumbClick.bind(this,activeKey)}>
                        <FontAwesome name='table' /> {activeKey==='inside'?'ตารางรายงานซ่อมยางภายใน':'ตารางรายงานซ่อมยางภายนอก'}
                    </Breadcrumb.Item>
                    <Breadcrumb.Item active={true} onClick={()=>{}}>
                        {activeKey==='inside'?'ใบงานซ่อมยางภายใน':'ใบงานซ่อมยางภายนอก'}
                    </Breadcrumb.Item>    
                </Breadcrumb>
                }
                <Switch>
                    <Route exact path="/inside" render={(props) => this.renderReportTyreRepairInsideTab()}/>                            
                    <Route exact path="/outside" render={(props) => this.renderReportTyreRepairTab()}/>                            
                    <Route render={(props) => this.renderReportTyreRepairInsideTab()}/>                         
                </Switch>
            </div>           
        )
    }
}

ReportAllTyreRepairPage.defaultProps = {
        
}

const _Connect = connect(
  (state) => ({messages: state.message.view.tyre.ReportAllTyreRepairPage}),null,null,{withRef:true}
)(ReportAllTyreRepairPage);

export default withRouter(_Connect)


// WEBPACK FOOTER //
// ./src/view/tyre/ReportAllTyreRepairPage.js